import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-menu border-r border-border-subtle bg-[rgba(249,246,240,0.95)] backdrop-blur-md"
}
const _hoisted_2 = { class: "menu-header" }
const _hoisted_3 = { class: "menu-links flex-1" }
const _hoisted_4 = {
  key: 0,
  class: "menu-cta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SiteHeaderLink = _resolveComponent("SiteHeaderLink")!
  const _component_LuxuryButton = _resolveComponent("LuxuryButton")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide-menu" }, {
    default: _withCtx(() => [
      (_ctx.isMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: "/#header",
                class: "font-interface text-base font-medium uppercase tracking-[0.2em] text-text-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" SNAPSHARE ")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: link.url,
                  class: "menu-item"
                }, [
                  _createVNode(_component_SiteHeaderLink, {
                    link: link,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu()))
                  }, null, 8, ["link"])
                ]))
              }), 128))
            ]),
            (_ctx.ctaLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_LuxuryButton, {
                    variant: "compact",
                    size: "md",
                    block: "",
                    to: _ctx.ctaLink.url,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMenu()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.ctaLink.text), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}